// extracted by mini-css-extract-plugin
module.exports = {"container":"Tooltip_container__28sHd","tooltip":"Tooltip_tooltip__2tsWT text-caption","arrow":"Tooltip_arrow__VoU13"};